const heroImage = require('./images/pasted-image-0-4.png');
const hpLogo = require('./images/logos/hp-logo.png');
const dellLogo = require('./images/logos/dell-logo.png');
const lenovoLogo = require('./images/logos/lenovo-logo.png');
const ciscoLogo = require('./images/logos/cisco-logo.png');
const appleLogo = require('./images/logos/apple-logo.png');
const samsungLogo = require('./images/logos/samsung-logo.png');

// Export images for use in components
export {
  heroImage,
  hpLogo,
  dellLogo,
  lenovoLogo,
  ciscoLogo,
  appleLogo,
  samsungLogo
};